import { useRef, useEffect } from 'react'

export default function useOutsideClick<T extends HTMLElement>(
  callback: () => void
) {
  const ref = useRef<null | T>(null)

  useEffect(() => {
    const handleClick = ({ target }: MouseEvent) => {
      if (!target) return

      const el = target as HTMLElement

      // Ignore clicks inside the country modal
      if (el.closest('#country-modal')) return

      if (ref.current && !ref.current.contains(el)) {
        callback()
      }
    }

    // keep capture: true to catch clicks before other handlers
    document.addEventListener('click', handleClick, true)

    return () => {
      document.removeEventListener('click', handleClick, true)
    }
  }, [callback])

  return ref
}
